<div class="row">
    <div class="col-12">
        <img [src]="getFileExt()" alt="" *ngIf="media" style="width:20px;margin-right:10px;"/>
        <input #inputFile type="file" (change)="changeListenerDoc($event)"  [hidden]="true" >
        {{ label | translate }} &nbsp;
        <div class="btn btn-primary btn-sm" (click)="addFile()" *ngIf="!media">
            <fa-icon [icon]="['fas', 'file']" ></fa-icon> &nbsp;
            {{ 'Add.file' | translate }}
        </div>
        <div class="btn btn-danger btn-sm" (click)="removeFile()" *ngIf="media">
            <fa-icon [icon]="['fas', 'times']" ></fa-icon> &nbsp;
            {{ 'Remove.file' | translate }}
        </div>
    </div>
</div>
